function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import classNames from 'classnames';
import { List } from 'immutable';
import { openTransientModal$ } from '@apiEnabler/api-enabler-common/lib/intents';
import { formatDate } from '../../date-utils';
import FromAndTo from './FromAndTo';
import PaymentReferenceNumbers, { VrpReferenceNumbers } from './PaymentReferenceNumbers';
import PaymentDetailItem from '../PaymentDetailItem';
import { getPaymentDetails, getConversionRateSummary, createMoneyFormatter } from './get-details-from-state';
import { convertAddressToString } from '../../address-utils';
import style from './Payment.module.css';
var PaymentDetails = function PaymentDetails(_ref) {
  var payment = _ref.payment,
    brand = _ref.brand,
    className = _ref.className,
    isStaffMember = _ref.isStaffMember;
  var paymentDetails = getPaymentDetails(payment);
  var debtor = payment.getIn(['payload', 'debtor']);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, 'zb-card')
  }, /*#__PURE__*/React.createElement(FromAndTo, {
    debtor: debtor,
    creditor: payment.getIn(['payload', 'creditor']),
    creditorAgentIdentification: paymentDetails.creditorAgentIdentification,
    creditorAgentScheme: paymentDetails.creditorAgentScheme,
    showLabels: paymentDetails.isInternational,
    paymentInstructions: List(paymentDetails.individualPayments),
    isBalanceTransfer: paymentDetails.isBalanceTransfer
  }), paymentDetails.isBalanceTransfer && /*#__PURE__*/React.createElement("div", {
    className: style.cardBody
  }, /*#__PURE__*/React.createElement(BalanceTransferOffer, {
    paymentDetails: paymentDetails
  })), !paymentDetails.isVrp && /*#__PURE__*/React.createElement("div", {
    className: classNames(style.cardBody, 'js-payment-details-group-1', 'js-payment-cardbody', _defineProperty({}, style.noBorder, paymentDetails.individualPayments > 0))
  }, isStaffMember && /*#__PURE__*/React.createElement(PaymentId, {
    paymentDetails: paymentDetails
  }), /*#__PURE__*/React.createElement(PaymentAmounts, {
    paymentDetails: paymentDetails
  }), /*#__PURE__*/React.createElement(PaymentDate, {
    paymentDetails: paymentDetails
  }), /*#__PURE__*/React.createElement(ServiceProvider, {
    paymentDetails: paymentDetails
  }), paymentDetails.isBalanceTransfer && showBalanceTransferDetails(paymentDetails)), paymentDetails.isInternational && /*#__PURE__*/React.createElement("div", {
    className: classNames(style.cardBody, 'js-payment-details-group-2', 'js-international-payment-cardbody')
  }, /*#__PURE__*/React.createElement(InternationalPaymentType, {
    paymentDetails: paymentDetails,
    brand: brand
  }), /*#__PURE__*/React.createElement(PurposeOfPayment, {
    paymentDetails: paymentDetails
  }), /*#__PURE__*/React.createElement(SendingTo, {
    paymentDetails: paymentDetails
  }), /*#__PURE__*/React.createElement(InternationalBank, {
    paymentDetails: paymentDetails
  }), /*#__PURE__*/React.createElement(PayeeAddress, {
    paymentDetails: paymentDetails
  })), paymentDetails.isInternational && /*#__PURE__*/React.createElement("div", {
    className: classNames(style.cardBody, 'js-payment-details-group-3', 'js-international-payment-cardbody-2')
  }, /*#__PURE__*/React.createElement(RemittanceInformation, {
    paymentDetails: paymentDetails
  }), /*#__PURE__*/React.createElement(PaymentFees, {
    paymentDetails: paymentDetails,
    brand: brand
  })), paymentDetails.isVrp && /*#__PURE__*/React.createElement("div", {
    className: classNames(style.cardBody, 'js-payment-details-group-vrp')
  }, /*#__PURE__*/React.createElement("div", {
    className: style.paymentTitle
  }, "Payment rules"), /*#__PURE__*/React.createElement(MaxTotalAmount, {
    paymentDetails: paymentDetails
  }), /*#__PURE__*/React.createElement(MaxAmountLimit, {
    paymentDetails: paymentDetails
  }), /*#__PURE__*/React.createElement(MaxPaymentAmount, {
    paymentDetails: paymentDetails
  }), /*#__PURE__*/React.createElement(MaxNumberOfPayments, {
    paymentDetails: paymentDetails
  }), /*#__PURE__*/React.createElement(MaxNumberPaymentsLimit, {
    paymentDetails: paymentDetails
  }), /*#__PURE__*/React.createElement(ValidFrom, {
    paymentDetails: paymentDetails
  })), paymentDetails.isVrp ? /*#__PURE__*/React.createElement(VrpReferenceNumbers, {
    payeeRef: paymentDetails.payeeRef
  }) : /*#__PURE__*/React.createElement(PaymentReferenceNumbers, {
    transactionRef: paymentDetails.transactionRef,
    payeeRef: paymentDetails.payeeRef
  }));
};
export default PaymentDetails;
function PaymentAmounts(_ref2) {
  var paymentDetails = _ref2.paymentDetails;
  var moneyFormatter = createMoneyFormatter(paymentDetails);
  var debitAmount = moneyFormatter(paymentDetails.debitAmount);
  if (paymentDetails.isBulk) {
    return /*#__PURE__*/React.createElement(PaymentDetailItem, {
      className: "js-payment-amount",
      label: "Total debit amount",
      value: debitAmount
    });
  }
  if (paymentDetails.isBalanceTransfer) {
    return /*#__PURE__*/React.createElement(PaymentDetailItem, {
      className: "js-transfer-amount",
      label: "Transfer amount",
      value: debitAmount
    });
  }
  var conversionRateSummary = getConversionRateSummary(paymentDetails, moneyFormatter);
  if (conversionRateSummary) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PaymentDetailItem, {
      className: "js-payment-amount",
      label: "Payment amount",
      value: debitAmount
    }), /*#__PURE__*/React.createElement(PaymentDetailItem, {
      className: "js-sending-amount",
      label: "Sending amount",
      value: moneyFormatter(paymentDetails.paymentAmount),
      valueAnnotation: conversionRateSummary
    }));
  }
  return /*#__PURE__*/React.createElement(PaymentDetailItem, {
    className: "js-payment-amount",
    label: "Payment amount",
    value: debitAmount
  });
}
function PaymentDate(_ref3) {
  var paymentDetails = _ref3.paymentDetails;
  if (paymentDetails.isBalanceTransfer) return null;else {
    var showValueDate = paymentDetails.type === 'SINGLE_IMMEDIATE' && paymentDetails.valueDate;
    var label = paymentDetails.isUpcoming ? 'Payment due' : showValueDate ? 'Approximate payment date' : 'Payment date';
    var date = paymentDetails.isBulk ? paymentDetails.bulkPaymentDate : paymentDetails.isUpcoming ? paymentDetails.upcomingPaymentDate : showValueDate ? paymentDetails.valueDate : paymentDetails.pastPaymentDate;
    var estimatedArrivalDateText = paymentDetails.estimatedArrivalDate && "Approx. date received ".concat(formatPaymentDate(paymentDetails.estimatedArrivalDate));
    return /*#__PURE__*/React.createElement(PaymentDetailItem, {
      className: "js-payment-date",
      label: label,
      value: formatPaymentDate(date),
      valueAnnotation: estimatedArrivalDateText
    });
  }
}
function PaymentFees(_ref4) {
  var paymentDetails = _ref4.paymentDetails,
    brand = _ref4.brand;
  var brandName = brand.get('name');
  var moneyFormatter = createMoneyFormatter(paymentDetails);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PaymentDetailItem, {
    className: "js-bank-fee",
    label: "".concat(brandName, " handling fees"),
    value: moneyFormatter(paymentDetails.fee || 0)
  }), !paymentDetails.isInternalTransfer && /*#__PURE__*/React.createElement(PaymentDetailItem, {
    className: "js-foreign-bank-fee",
    label: "Foreign bank handling fees",
    value: paymentDetails.foreignBankFee ? moneyFormatter(paymentDetails.foreignBankFee) : /*#__PURE__*/React.createElement("span", {
      className: style.feesMessage
    }, "Please note that the foreign bank may deduct a handling fee from the amount sent")
  }), paymentDetails.totalToPay && /*#__PURE__*/React.createElement(PaymentDetailItem, {
    className: "js-foreign-bank-fee",
    label: "Total to pay (indicative)",
    value: moneyFormatter(paymentDetails.totalToPay)
  }));
}
function ServiceProvider(_ref5) {
  var paymentDetails = _ref5.paymentDetails;
  var showTppInfo = paymentDetails.type.indexOf('SINGLE_IMMEDIATE') !== -1;
  return showTppInfo && /*#__PURE__*/React.createElement(PaymentDetailItem, {
    className: "js-service-provider",
    label: "Service Provider",
    value: paymentDetails.clientName,
    valueAnnotation: /*#__PURE__*/React.createElement("button", {
      className: "zb-button-link",
      onClick: function onClick() {
        return openTransientModal$.next({
          type: 'service-provider.info'
        });
      }
    }, "What's this?")
  });
}
function InternationalPaymentType(_ref6) {
  var brand = _ref6.brand,
    paymentDetails = _ref6.paymentDetails;
  var internationalPaymentTypeDefinitions = !paymentDetails.isInternalTransfer && brand.getIn(['links', 'internationalPaymentTypeDefinitions']);
  return /*#__PURE__*/React.createElement(PaymentDetailItem, {
    className: "js-payment-type",
    label: "Payment type",
    value: getInternationalPaymentType(paymentDetails),
    valueAnnotation: internationalPaymentTypeDefinitions && /*#__PURE__*/React.createElement("a", {
      href: internationalPaymentTypeDefinitions,
      rel: "noopener noreferrer",
      target: "_blank",
      "aria-label": "More information on Payment types, an external link that will open in a new tab"
    }, "Payment types explained")
  });
}
function PurposeOfPayment(_ref7) {
  var paymentDetails = _ref7.paymentDetails;
  return paymentDetails.purpose ? /*#__PURE__*/React.createElement(PaymentDetailItem, {
    className: "js-purpose-of-payment",
    label: "Purpose of payment code (POP code)",
    value: paymentDetails.purpose
  }) : null;
}
function SendingTo(_ref8) {
  var paymentDetails = _ref8.paymentDetails;
  return paymentDetails.destinationCountryName ? /*#__PURE__*/React.createElement(PaymentDetailItem, {
    className: "js-sending-to",
    label: "Sending to",
    value: paymentDetails.destinationCountryName
  }) : null;
}
function InternationalBank(_ref9) {
  var paymentDetails = _ref9.paymentDetails;
  var bankAddress = (paymentDetails.bankAddress || []).join('\n');
  return bankAddress ? /*#__PURE__*/React.createElement(PaymentDetailItem, {
    className: "js-international-bank",
    label: "International bank",
    value: /*#__PURE__*/React.createElement("span", {
      className: style.address
    }, bankAddress)
  }) : null;
}
function PayeeAddress(_ref10) {
  var paymentDetails = _ref10.paymentDetails;
  var payeeAddress = paymentDetails.isInternational && paymentDetails.payeeAddress && convertAddressToString(paymentDetails.payeeAddress, paymentDetails.creditorCountryName);
  return payeeAddress ? /*#__PURE__*/React.createElement(PaymentDetailItem, {
    className: "js-payee-address",
    label: "Payee address",
    value: /*#__PURE__*/React.createElement("span", {
      className: style.address
    }, payeeAddress)
  }) : null;
}
function RemittanceInformation(_ref11) {
  var paymentDetails = _ref11.paymentDetails;
  return paymentDetails.remittance ? /*#__PURE__*/React.createElement(PaymentDetailItem, {
    className: "js-remittance",
    label: "Remittance information",
    value: paymentDetails.remittance
  }) : null;
}
function BalanceTransferOffer(_ref12) {
  var paymentDetails = _ref12.paymentDetails;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(style.offerSection, 'js-offer-details')
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(style.offerLabel, 'js-offer-label')
  }, "Offer"), /*#__PURE__*/React.createElement("div", {
    className: classNames(style.offerText, 'js-offer-text')
  }, paymentDetails.balanceTransferDetails.description));
}
function showBalanceTransferDetails(paymentDetails) {
  var moneyFormatter = createMoneyFormatter(paymentDetails);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PaymentDetailItem, {
    className: "js-transfer-fee",
    label: "Transfer fee",
    value: moneyFormatter({
      amount: paymentDetails.balanceTransferDetails.transferFee
    })
  }), /*#__PURE__*/React.createElement(PaymentDetailItem, {
    className: "js-total-amount",
    label: "Total amount",
    value: moneyFormatter({
      amount: paymentDetails.balanceTransferDetails.totalAmount
    })
  }));
}
function PaymentId(_ref13) {
  var paymentDetails = _ref13.paymentDetails;
  return /*#__PURE__*/React.createElement(PaymentDetailItem, {
    className: "js-payment-id",
    label: "Payment ID",
    value: /*#__PURE__*/React.createElement("span", {
      className: style.breakAll
    }, paymentDetails.id)
  });
}
function formatPaymentDate(date) {
  return formatDate(date, 'DD MMMM YYYY');
}
function MaxPaymentAmount(_ref14) {
  var paymentDetails = _ref14.paymentDetails;
  if (!paymentDetails.maximumIndividualAmount) return null;
  var moneyFormatter = createMoneyFormatter(paymentDetails);
  return /*#__PURE__*/React.createElement(PaymentDetailItem, {
    className: "js-max-payment-amount",
    label: "Max payment amount",
    value: moneyFormatter({
      amount: paymentDetails.maximumIndividualAmount,
      currency: paymentDetails.maximumIndividualAmountCurrency
    })
  });
}
function MaxAmountLimit(_ref15) {
  var paymentDetails = _ref15.paymentDetails;
  if (!paymentDetails.maximumCumulativeAmount) return null;
  var moneyFormatter = createMoneyFormatter(paymentDetails);
  return /*#__PURE__*/React.createElement(PaymentDetailItem, {
    className: "js-max-amount-limit",
    label: "Max amount limit",
    value: moneyFormatter({
      amount: paymentDetails.maximumCumulativeAmount,
      currency: paymentDetails.maximumCumulativeAmountCurrency
    })
  });
}
function MaxTotalAmount(_ref16) {
  var paymentDetails = _ref16.paymentDetails;
  if (!paymentDetails.maxTotalAmount.length) return null;
  var moneyFormatter = createMoneyFormatter(paymentDetails);
  var value = /*#__PURE__*/React.createElement(React.Fragment, null, paymentDetails.maxTotalAmount.map(function (periodicLimit) {
    return renderVrpFrequencyBasedRow(moneyFormatter({
      amount: periodicLimit.amount,
      currency: periodicLimit.currency
    }), periodicLimit.period.length.toLowerCase());
  }));
  return /*#__PURE__*/React.createElement(PaymentDetailItem, {
    className: "js-max-total-amount",
    label: "Max total amount",
    value: value
  });
}
function MaxNumberOfPayments(_ref17) {
  var paymentDetails = _ref17.paymentDetails;
  if (!paymentDetails.maxNumberOfPayments.length) return null;
  var value = /*#__PURE__*/React.createElement(React.Fragment, null, paymentDetails.maxNumberOfPayments.map(function (periodicLimit) {
    return renderVrpFrequencyBasedRow(periodicLimit.numberOfPayments, periodicLimit.period.length.toLowerCase());
  }));
  return /*#__PURE__*/React.createElement(PaymentDetailItem, {
    className: "js-max-number-of-payments",
    label: "Max number of payments",
    value: value
  });
}
function MaxNumberPaymentsLimit(_ref18) {
  var paymentDetails = _ref18.paymentDetails;
  if (!paymentDetails.maximumCumulativeNumberOfPayments) return null;
  return /*#__PURE__*/React.createElement(PaymentDetailItem, {
    className: "js-payment-amount",
    label: "Max number payments limit",
    value: paymentDetails.maximumCumulativeNumberOfPayments
  });
}
function ValidFrom(_ref19) {
  var paymentDetails = _ref19.paymentDetails;
  if (!paymentDetails.validFrom) return null;
  return /*#__PURE__*/React.createElement(PaymentDetailItem, {
    className: "js-payment-valid-from",
    label: "Valid from",
    value: formatPaymentDate(paymentDetails.validFrom)
  });
}
function renderVrpFrequencyBasedRow(value, period) {
  return /*#__PURE__*/React.createElement("div", {
    key: period
  }, value, " every ", period);
}
function getInternationalPaymentType(paymentDetails) {
  if (paymentDetails.isInternalTransfer) {
    return paymentDetails.isUpcoming ? 'Future Dated IAT' : 'Inter Account Transfer';
  }
  return paymentDetails.isUrgent ? 'Urgent International' : 'Standard International';
}